import BaseTableColumn from "../../sisu/table/BaseTableColumn.sisu"

const NeoTableColumn = BaseTableColumn

export default NeoTableColumn